/**
 * Sample Spots Data
 * Real spots are loaded dynamically from /data/spots/*.json via spotLoader.js
 */

export const sampleSpots = []
